import { render, staticRenderFns } from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=template&id=2bc3a906&scoped=true&"
import script from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-fasciaBoardAlterEdit.vue?vue&type=style&index=0&id=2bc3a906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3a906",
  null
  
)

export default component.exports